import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import styles from './background-color-option.module.scss';

interface BackgroundColorOptionProps {
  panelId: string;
  onClickColorFill(index: number): void;
  fillObject: FillObject;
}

export function BackgroundColorOption({...props}: BackgroundColorOptionProps): ReactElement | null {
  if (props.fillObject.fillType === FillTypes.NONE) {
    return null;
  }

  const getColorObject = (color: RGBA): ColorFillStorage[] => {
    return [
      {
        id: 'color-fill-vector',
        color: getColorObjectArrayFromFillColor([color]),
      },
    ];
  };

  const onClickColorFill = (index: number): void => {
    props.onClickColorFill(index);
  };

  const getLabel = (index: number): string => {
    if (props.fillObject.fillType === FillTypes.SOLID) {
      return window.i18next.t('pmwjs_color');
    }

    if (index === 0) {
      return window.i18next.t('pmwjs_color_one');
    }
    return window.i18next.t('pmwjs_color_two');
  };

  const getColorOptions = (): ReactElement[] => {
    return props.fillObject.fillColor.map((color, index) => {
      return (
        <ContextualMenuColorFillOption
          key={`vector-fill-color-${index}`}
          id="vector-fill-color-option"
          label={getLabel(index)}
          data={getColorObject(color)}
          onClick={(): void => {
            onClickColorFill(index);
          }}
        />
      );
    });
  };

  return <ul className={`spacing-m-b-4 spacing-m-l-0 spacing-m-r-0 spacing-m-t-0 flexbox flex-column-reverse _full-width ${styles.container}`}>{getColorOptions()}</ul>;
}
